(function(){
  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.from((c||document).querySelectorAll(s))}

  // Mobile menu
  var menu=qs('[data-mobile-menu]'), toggle=qs('[data-menu-toggle]');
  if(toggle&&menu){toggle.addEventListener('click',function(){var open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;document.body.classList.toggle('menu-open',!open);});}

  // Quantity buttons
  qsa('[data-qty-minus]').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement.querySelector('input');i.value=Math.max(1,(parseInt(i.value,10)||1)-1);});});
  qsa('[data-qty-plus]').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement.querySelector('input');i.value=(parseInt(i.value,10)||1)+1;});});

  // Quick add
  qsa('[data-quick-add]').forEach(function(btn){btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var id=btn.dataset.productId;btn.disabled=true;var old=btn.textContent;btn.textContent='Adding…';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})}).then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(){return fetch('/cart.js')}).then(function(r){return r.json()}).then(function(cart){qsa('[data-cart-count]').forEach(function(c){c.textContent=cart.item_count;c.hidden=cart.item_count===0});btn.textContent='Added ✓';setTimeout(function(){btn.textContent=old;btn.disabled=false},1200)}).catch(function(){btn.textContent='Try again';setTimeout(function(){btn.textContent=old;btn.disabled=false},1200)});});});

  // Product form: variant sync (price + image + select value)
  var form=qs('[data-product-form]');
  if(form){
    var select=qs('[data-variant-select]',form);
    var radios=qsa('.variant-options input[type=radio]',form);
    var addBtn=qs('[name="add"]',form);
    // Search full document, not just inside form
    var productData=JSON.parse((qs('[data-product-json]')||{textContent:'null'}).textContent);

    function getChosen(){
      var c={};
      radios.forEach(function(r){
        if(r.checked){var n=r.name.match(/options\[(.*?)\]/);if(n)c[n[1]]=r.value;}
      });
      return c;
    }

    function updateGallery(variant){
      if(!variant||!variant.featured_image)return;
      var targetSrc=variant.featured_image.src;
      // Find the gallery image that matches and scroll/show it first
      var gallery=qs('.product-gallery');
      if(!gallery)return;
      var imgs=qsa('.gallery-image img',gallery);
      imgs.forEach(function(img){
        // Compare by checking if src contains the image filename
        var fname=targetSrc.split('?')[0].split('/').pop();
        if(img.src&&img.src.indexOf(fname)>-1){
          img.closest('.gallery-image').scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
        }
      });
    }

    function sync(){
      if(!select||!radios.length||!productData)return;
      var chosen=getChosen();
      var variant=productData.variants.find(function(v){
        return v.options.every(function(val,i){return chosen[productData.options[i]]===val;});
      });
      if(!variant)return;

      // Fix variant ID submitted with form
      select.value=variant.id;
      Array.from(select.options).forEach(function(o){o.selected=String(o.value)===String(variant.id);});

      // Fix add to cart button state
      if(addBtn){addBtn.disabled=!variant.available;addBtn.textContent=variant.available?'Add to cart':'Sold out';}

      // Fix price display
      var priceEl=qs('.price-current')||qs('[data-price]')||qs('.price .money')||qs('.price');
      if(priceEl){priceEl.textContent='Rs. '+(variant.price/100).toFixed(2);}

      // Fix gallery image
      updateGallery(variant);
    }

    radios.forEach(function(r){r.addEventListener('change',sync);});
    sync();
  }
})();
